import ufeApi from 'services/api/ufeApi';
import headerUtils from 'utils/Headers';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const { userXTimestampHeader } = headerUtils;

// https://jira.sephora.com/wiki/display/ILLUMINATE/Create+BI+Account+API

function createBiAccount(input) {
    const emailOptIn = input?.subscription?.subScribeToEmails ?? true;
    const body = {
        biAccount: {
            birthDay: input.biAccount?.birthDay,
            birthMonth: input.biAccount?.birthMonth,
            emailOptIn,
            accountType: 'BI'
        },
        profileId: Storage.local.getItem(LOCAL_STORAGE.PROFILE_ID)
    };

    return ufeApi
        .makeRequest('/gway/v2/bi/account', {
            method: 'PUT',
            headers: userXTimestampHeader(),
            body: JSON.stringify(body)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default createBiAccount;
